import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { abyssColors } from '@/theme/colors';
import { CircularBarChart } from './CircularBarChart';

type Calculations = {
  calculated: number;
  nonCalculated: number;
};

const SharedEsSheetGraph = ({ calculations }: { calculations?: Calculations }) => {
  if (!calculations) return undefined;

  const colorBlocks = [
    { label: 'Calculated', color: abyssColors.success[500] },
    { label: 'Not Calculated', color: abyssColors.primary[100] },
  ];

  return (
    <Box
      sx={{ display: 'flex', position: 'relative', flexDirection: 'column', alignItems: 'center' }}
    >
      <CircularBarChart
        data={[
          ...(calculations.calculated === 0
            ? []
            : [{ key: 'Calculated', count: calculations.calculated }]),
          ...(calculations.nonCalculated === 0
            ? []
            : [{ key: 'Not Calculated', count: calculations.nonCalculated }]),
        ]}
        displayConfig={[
          { fieldValue: 'Calculated', color: abyssColors.success[500] },
          { fieldValue: 'Not Calculated', color: abyssColors.primary[100] },
        ]}
      />

      <Stack direction="row" spacing={2} sx={{ marginTop: { sm: 4, lg: 2 }, alignSelf: 'flex-start' }}>
        {colorBlocks.map((block) => (
          <Stack key={block.label} direction="row" alignItems="center" spacing={0.75}>
            <Box
              sx={{
                width: '1rem',
                height: '1rem',
                backgroundColor: block.color,
                borderRadius: '2px',
              }}
            />
            <Typography fontSize="1.1rem" lineHeight="normal" color={abyssColors.primary[300]}>
              {block.label}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
};

export default SharedEsSheetGraph;
